import React from 'react';
import { 
  FileText, 
  Users, 
  CheckCircle, 
  Target, 
  BarChart3, 
  Award, 
  TrendingUp, 
  Star 
} from 'lucide-react';

const BulletinStatisticsCards = ({ statistiques }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {/* Total Bulletins */}
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl shadow-lg border border-blue-200 p-6 hover:shadow-xl transition-all duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-blue-700 uppercase tracking-wide">Total Bulletins</p>
            <p className="text-3xl font-bold text-blue-900 mt-2">{statistiques.total_bulletins || 0}</p>
            <div className="flex items-center mt-2">
              <Users className="h-4 w-4 text-blue-600 mr-1" />
              <span className="text-xs text-blue-600">Étudiants inscrits</span>
            </div>
          </div>
          <div className="p-4 bg-blue-200 rounded-2xl">
            <FileText className="h-8 w-8 text-blue-700" />
          </div>
        </div>
      </div>

      {/* Bulletins Validés */}
      <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-lg border border-green-200 p-6 hover:shadow-xl transition-all duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-green-700 uppercase tracking-wide">Validés</p>
            <p className="text-3xl font-bold text-green-900 mt-2">{statistiques.bulletins_valides || 0}</p>
            <div className="flex items-center mt-2">
              <CheckCircle className="h-4 w-4 text-green-600 mr-1" />
              <span className="text-xs text-green-600">Bulletins approuvés</span>
            </div>
          </div>
          <div className="p-4 bg-green-200 rounded-2xl">
            <Award className="h-8 w-8 text-green-700" />
          </div>
        </div>
      </div>

      {/* Taux de Validation */}
      <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl shadow-lg border border-purple-200 p-6 hover:shadow-xl transition-all duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-purple-700 uppercase tracking-wide">Taux Validation</p>
            <p className="text-3xl font-bold text-purple-900 mt-2">{statistiques.taux_validation || 0}%</p>
            <div className="flex items-center mt-2">
              <Target className="h-4 w-4 text-purple-600 mr-1" />
              <span className="text-xs text-purple-600">Progression</span>
            </div>
          </div>
          <div className="p-4 bg-purple-200 rounded-2xl">
            <TrendingUp className="h-8 w-8 text-purple-700" />
          </div>
        </div>
        {/* Barre de progression */}
        <div className="mt-4">
          <div className="w-full bg-purple-200 rounded-full h-2">
            <div 
              className="bg-purple-600 h-2 rounded-full transition-all duration-500" 
              style={{ width: `${statistiques.taux_validation || 0}%` }}
            ></div>
          </div>
        </div>
      </div>

      {/* Moyenne Classe */}
      <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl shadow-lg border border-orange-200 p-6 hover:shadow-xl transition-all duration-300">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-orange-700 uppercase tracking-wide">Moyenne Classe</p>
            <p className="text-3xl font-bold text-orange-900 mt-2">{statistiques.moyenne_classe || 0}<span className="text-lg">/20</span></p>
            <div className="flex items-center mt-2">
              <BarChart3 className="h-4 w-4 text-orange-600 mr-1" />
              <span className="text-xs text-orange-600">Performance générale</span>
            </div>
          </div>
          <div className="p-4 bg-orange-200 rounded-2xl">
            <Star className="h-8 w-8 text-orange-700" />
          </div>
        </div>
        {/* Indicateur de performance */}
        <div className="mt-4">
          <div className="flex items-center justify-between text-xs">
            <span className="text-orange-600">0</span>
            <span className="text-orange-600">20</span>
          </div>
          <div className="w-full bg-orange-200 rounded-full h-2 mt-1">
            <div 
              className="bg-orange-600 h-2 rounded-full transition-all duration-500" 
              style={{ width: `${((statistiques.moyenne_classe || 0) / 20) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulletinStatisticsCards;